<template>
  <v-card
    height="80"
    width="253"
    outlined
    elevation="0"
    class="task-container mr-4"
  >
    <v-progress-linear
      :height="3"
      :indeterminate="isLoading"
      :active="isLoading"
    />
    <v-card-text
      class="d-flex pa-2 flex-grow-1 h-100 justify-center align-center"
    >
      <v-icon class="mr-2" size="40" color="blue-grey">
        {{ fileIcon }}
      </v-icon>

      <div class="d-flex flex-column align-start flex-grow-1">
        <p v-snip="2" class="body-2 ma-0 pa-0">
          {{ fileName }}
        </p>

        <div class="d-flex w-100 justify-space-between">
          <p class="caption blue-grey--text text--lighten-2 ma-0 pa-0">
            {{ sizeText }}
          </p>

          <v-icon
            v-if="!readOnly"
            size="22"
            color="primary"
            @click="$emit('download')"
          >
            mdi-download-circle-outline
          </v-icon>
        </div>
      </div>
    </v-card-text>
    <div v-if="!readOnly">
      <v-icon
        v-if="!readOnly"
        size="22"
        color="blue-grey darken-2"
        class="task-delete-button rounded-circle"
        @click="$emit('closeClick')"
      >
        mdi-close-circle
      </v-icon>
    </div>
  </v-card>
</template>
<script>
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'TaskAttachmentCard',

  mixins: [mixin],

  components: {},
  props: {
    name: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    sizeText() {
      if (!this.size) return 0
      return this.formatBytes(this.size)
    },

    fileName() {
      return this.name ?? ''
    },

    fileIcon() {
      return this.getFileIconByExtension(this.name)
    },
  },

  methods: {
    formatBytes(bytes, decimals = 2) {
      //  https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
  },
}
</script>

<style lang="scss" scoped>
.task-container {
  position: relative !important;
  &:hover {
    background-color: $color-blue-grey-lighten3;
  }
}

.task-delete-button {
  width: 24px !important;
  height: 24px !important;
  position: absolute;
  top: -8px;
  right: -6px;
  background-color: white;
}
</style>
